import React, { useEffect, useState } from "react";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import greatSoulImg from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import greatDecorate from "../../assets/images/coursesPage/LordGaveBapu/png/bapuBgDecorate.png";
import orangeTick from "../../assets/images/svg/orenge_tick.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";
import { ModalList } from "../../utils/TheGreateSageHelper";
import Modal from "../common/modal/Modal";
import { greateSageList } from "../../utils/TheGreateSageHelper";
const TheGreatSage = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }

    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="position-relative great_souls pt-2">
        {/*<img
          className="position-absolute bottom_flower_mahamantra end-0 maharaj_top z_index_n2"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/} 
        <img
          src={greatSoulImg}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="temple_the_great_souls"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute start-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute end-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra souls_top_flower start-0 the_great_flower"
          src={topFlowerImg}
          alt="top_flower"
        />*/}

        <div className="container_modified container position-relative mt-0 pt-3 pt-sm-4">
          <div className="row justify-content-center mt-xl-2">
            <div className="col-lg-11 text-center mb-4 pb-lg-2">
              <CommonHeading
                heading="The Finest Ashram in Girnar"
                className="text-orange common_heading_text common_heading_text_brown"
              />
              <h2 className="common_sub_heading text-center mb-1 mb-md-3 px-4 px-md-0">
                SHREE GIRNAR SADHNA ASHRAM
              </h2>
            </div>
          </div>
          <div className="row justify-content-between mb-3 pb-3">
            <div className="col-lg-12">
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-5">
                  This ashram was established in 1973 by Poojya Maharishi Shri Punitachariji in the foothills of holy Girnar Mountain near Junagadh in the west of Gujarat (India). The ashram is situated on Dattatreya road behind Bhavanatha Temple at a distance of about one kilometer from there; ashram is connected with motor able road. Those traveling by air can reach Junagadh by train or road from Ahmedabad or Rajkot. Surroundings of the ashram are very scenic. Poojya Maharishi Shri had the Darshan of Sadguru Dattatreya on a rock behind the ashram premises. Chanting of the mantra ‘Hari Om Tatsat Jai Guru Datta” keeps on reverberating all the time here. Group prayer, chanting and meditation are held reaularly in the mornings in the meditation hall. While group chanting, meditation and satsanga with Poojya Bapushri and Poojya Maiyashri are held in the satsanga hall in the evenings.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                  This ashram is completely non-sectarian. Everybody, man or woman, brahman or non-brahman, rich or poor, adherent to any religion or sect receives the same and no difference is made amongst them. All the sadhakas live together, eat together, and carry out prayers, chanting and meditation together. Sadhaka coining to this ashram need not change his Guru or Guru-mantra. Every sadhaka in the ashram has to put in his best efforts to advance in the direction of attainment of the life’s aim through progress in sadhana and meditation-a stage easily and spontaneously reached at through the chanting of the benedictory maha mantra ‘Hari Om Tatsat Jai guru Datta’ along with the japa of his own Guru-mantra. Practically all types of facilities e.g. meditation kutirs, guest house, satsanga hall, meditation hall, yagyashala, cowshed, kitchen, dining hall etc. needed for carrying out bhajan, sadhana, upasana are available in this ashram It has a land area of about 55 acres.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                 This ashram, is administered by a registered trust and the donations given to the trust are tax free as per rules.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100 z_index_4"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default TheGreatSage;
